var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137.37 35.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #07090a;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 8.62,
    x2: 22.52,
    y2: 8.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4778bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fc6f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 19.98,
    x2: 29.15,
    y2: 19.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11.17,
    y1: 28.99,
    x2: 29.12,
    y2: 28.99,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.52,4.53s0,.05,0,.07c-.01.42-.23.84-.64,1.07L1.91,17.07c-.85.48-1.91-.13-1.91-1.11v-6.11c0-.45.24-.87.63-1.1L15.14.18c.18-.11.38-.17.59-.18.04,0,.07,0,.11,0,0,0,0,0,0,0,.21,0,.42.07.6.18l5.45,3.3c.4.24.6.64.61,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.15,13.52s0,.05,0,.07c-.01.42-.22.83-.63,1.07l-20.15,11.8c-.39.23-.63.65-.63,1.1v1.94c0,.98-1.05,1.59-1.9,1.11l-5.19-2.95c-.4-.23-.65-.65-.65-1.11v-3.62c0-.45.24-.87.63-1.1l21.36-12.48c.25-.15.54-.2.82-.16,0,0,0,0,0,0,.16.02.32.08.47.17l5.24,3.11c.4.24.61.65.62,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.12,26.68s0,.05,0,.07c-.01.42-.22.83-.63,1.07l-12.94,7.56c-.38.22-.85.23-1.24.03l-2.47-1.3c-.42-.22-.68-.65-.68-1.13v-3.51c0-.46.25-.88.65-1.11l10.16-5.77c.22-.13.47-.18.72-.16.01,0,.02,0,.03,0,.18.02.35.07.51.16l5.24,3.02c.41.24.63.65.64,1.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.46,25.69c-2.27,0-4.16-.76-5.66-2.27-1.5-1.51-2.25-3.39-2.25-5.64s.75-4.13,2.25-5.64c1.5-1.51,3.37-2.27,5.6-2.27s3.88.71,5.2,2.12c1.32,1.41,2.03,3.34,2.13,5.8v.92h-11.68c.16,1.08.65,1.96,1.47,2.64.82.67,1.8,1.01,2.94,1.01,1.61,0,2.94-.58,3.99-1.75l2.27,2.42c-.7.8-1.58,1.44-2.67,1.93-1.08.49-2.28.74-3.59.74ZM45.15,12.96c-.92,0-1.75.28-2.5.84-.75.56-1.25,1.32-1.52,2.28h7.88c-.41-2.09-1.7-3.13-3.86-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.95,25.45v-8.92c0-.92-.27-1.72-.81-2.41-.54-.68-1.32-1.03-2.35-1.03-1.59,0-2.71.89-3.34,2.67.02.16.03.4.03.71v8.99h-3.37v-8.92c0-.92-.28-1.72-.83-2.41-.55-.68-1.34-1.03-2.36-1.03-1.59,0-2.7.87-3.31,2.61v9.75h-3.37v-15.33h3.37v1.44c1-1.12,2.32-1.69,3.96-1.69,2.11,0,3.7.79,4.78,2.36,1.19-1.57,2.87-2.36,5.06-2.36,1.86,0,3.31.6,4.36,1.79,1.04,1.2,1.56,2.8,1.56,4.8v8.99h-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.78,23.42c-1.51,1.51-3.4,2.27-5.67,2.27s-4.16-.76-5.67-2.27c-1.51-1.51-2.27-3.39-2.27-5.64s.76-4.13,2.27-5.64,3.4-2.27,5.67-2.27,4.16.76,5.67,2.27c1.51,1.51,2.27,3.39,2.27,5.64s-.76,4.13-2.27,5.64ZM87.1,22.47c1.29,0,2.36-.44,3.2-1.33.85-.89,1.27-2.01,1.27-3.36s-.42-2.47-1.27-3.36c-.85-.89-1.92-1.33-3.2-1.33s-2.38.44-3.22,1.33c-.84.89-1.26,2.01-1.26,3.36s.42,2.47,1.26,3.36c.84.89,1.91,1.33,3.22,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.05,25.69l-8.4-15.58h3.8l4.6,9.02,4.54-9.02h3.86l-8.4,15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.11,25.45v-1.41c-1.02,1.1-2.45,1.66-4.29,1.66s-3.41-.6-4.54-1.81c-1.12-1.21-1.69-2.8-1.69-4.78v-8.99h3.37v8.92c0,.9.32,1.7.95,2.39.63.7,1.48,1.04,2.55,1.04,1.8,0,3.02-.87,3.65-2.61v-9.75h3.37v15.33h-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.94,25.45v-15.33h3.37v1.5c.96-1.14,2.28-1.72,3.96-1.72.39,0,.76.03,1.1.09v3.53c-.43-.14-.99-.21-1.69-.21-1.62,0-2.74.61-3.37,1.84v10.3h-3.37Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmo);
export default __webpack_public_path__ + "static/media/emo.cee1af8cbe8addd2d377b6196916587b.svg";
export { ForwardRef as ReactComponent };